import { connect } from 'react-redux';
import Action from '../state/Action';
import Select from '../state/Select';

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: Select.users.getActiveUser(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    login: function login() {
      dispatch(Action.components.set('App_Container', 'loginOverlayOpen', true));
    },
    logout: function logout() {
      dispatch(Action.users.apiLogoutUser());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps);